import React from 'react';
import PropTypes from 'prop-types';
import Table from 'src/components/table/Table';
import UsePermission from 'src/hoc/UsePermission';

const VehicleInsuranceQuotationList = (props) => {
    const {
        onApproveClick,
        quotations,
        canApprove,
    } = props;

    const hasApprovePermission = UsePermission({ scope: 'flow.case_manager.vehicle_insurance_quotations.approve' });

    return (
        <div className="card mt-3">
            <div className="card-body">
                <h5 className="card-title">Quotations</h5>
                <Table
                    recordsPerPage={quotations?.length}
                    searchData={{
                        data: quotations,
                        count: quotations?.length,
                        currentPage: 0,
                    }}
                    columns={{
                        vehicleIdvValue: {
                            display: 'vehicleIdvValue',
                            path: 'vehicleIdvValue',
                        },
                        ratePercentage: {
                            display: 'ratePercentage',
                            path: 'ratePercentage',
                        },
                        rateValue: {
                            display: 'rateValue',
                            path: 'rateValue',
                        },
                        loadingDiscountPercentage: {
                            display: 'loadingDiscountPercentage',
                            path: 'loadingDiscountPercentage',
                        },
                        loadingDiscountValue: {
                            display: 'loadingDiscountValue',
                            path: 'loadingDiscountValue',
                        },
                        nonElectAccIdVPercentage: {
                            display: 'nonElectAccIdVPercentage',
                            path: 'nonElectAccIdVPercentage',
                        },
                        nonElectAccIdvValue: {
                            display: 'nonElectAccIdvValue',
                            path: 'nonElectAccIdvValue',
                        },
                        nonElectAccIdvCharges: {
                            display: 'nonElectAccIdvCharges',
                            path: 'nonElectAccIdvCharges',
                        },
                        cndIdvPercentage: {
                            display: 'cndIdvPercentage',
                            path: 'cndIdvPercentage',
                        },
                        cndIdvValue: {
                            display: 'cndIdvValue',
                            path: 'cndIdvValue',
                        },
                        cndIdvCharges: {
                            display: 'cndIdvCharges',
                            path: 'cndIdvCharges',
                        },
                        electIdvPercentage: {
                            display: 'electIdvPercentage',
                            path: 'electIdvPercentage',
                        },
                        electIdvValue: {
                            display: 'electIdvValue',
                            path: 'electIdvValue',
                        },
                        electIdvCharges: {
                            display: 'electIdvCharges',
                            path: 'electIdvCharges',
                        },
                        odPremiumValue: {
                            display: 'odPremiumValue',
                            path: 'odPremiumValue',
                        },
                        vexValue: {
                            display: 'vexValue',
                            path: 'vexValue',
                        },
                        insuranceValueAfterVex: {
                            display: 'insuranceValueAfterVex',
                            path: 'insuranceValueAfterVex',
                        },
                        ncbPercentage: {
                            display: 'ncbPercentage',
                            path: 'ncbPercentage',
                        },
                        ncbValue: {
                            display: 'ncbValue',
                            path: 'ncbValue',
                        },
                        insuranceValueAfterNcb: {
                            display: 'insuranceValueAfterNcb',
                            path: 'insuranceValueAfterNcb',
                        },
                        zeroDepreciationPercentage: {
                            display: 'zeroDepreciationPercentage',
                            path: 'zeroDepreciationPercentage',
                        },
                        zeroDepreciationValue: {
                            display: 'zeroDepreciationValue',
                            path: 'zeroDepreciationValue',
                        },
                        consumablePercentage: {
                            display: 'consumablePercentage',
                            path: 'consumablePercentage',
                        },
                        consumableValue: {
                            display: 'consumableValue',
                            path: 'consumableValue',
                        },
                        enginePercentage: {
                            display: 'enginePercentage',
                            path: 'enginePercentage',
                        },
                        engineValue: {
                            display: 'engineValue',
                            path: 'engineValue',
                        },
                        returnToInvoicePercentage: {
                            display: 'returnToInvoicePercentage',
                            path: 'returnToInvoicePercentage',
                        },
                        returnToInvoiceValue: {
                            display: 'returnToInvoiceValue',
                            path: 'returnToInvoiceValue',
                        },
                        goldPlanValue: {
                            display: 'goldPlanValue',
                            path: 'goldPlanValue',
                        },
                        addonOdPremiumValue: {
                            display: 'addonOdPremiumValue',
                            path: 'addonOdPremiumValue',
                        },
                        insuranceValueAfterAddonOd: {
                            display: 'insuranceValueAfterAddonOd',
                            path: 'insuranceValueAfterAddonOd',
                        },
                        addonDiscountValue: {
                            display: 'addonDiscountValue',
                            path: 'addonDiscountValue',
                        },
                        newOdPremiumValue: {
                            display: 'newOdPremiumValue',
                            path: 'newOdPremiumValue',
                        },
                        thirdPartyValue: {
                            display: 'thirdPartyValue',
                            path: 'thirdPartyValue',
                        },
                        ownerValue: {
                            display: 'ownerValue',
                            path: 'ownerValue',
                        },
                        paidDriverValue: {
                            display: 'paidDriverValue',
                            path: 'paidDriverValue',
                        },
                        passengerValue: {
                            display: 'passengerValue',
                            path: 'passengerValue',
                        },
                        cngThirdPartyValue: {
                            display: 'cngThirdPartyValue',
                            path: 'cngThirdPartyValue',
                        },
                        empLiabValue: {
                            display: 'empLiabValue',
                            path: 'empLiabValue',
                        },
                        homeSecureValue: {
                            display: 'homeSecureValue',
                            path: 'homeSecureValue',
                        },
                        comprehensiveValue: {
                            display: 'comprehensiveValue',
                            path: 'comprehensiveValue',
                        },
                        gstTaxPercentage: {
                            display: 'gstTaxPercentage',
                            path: 'gstTaxPercentage',
                        },
                        gstTaxValue: {
                            display: 'gstTaxValue',
                            path: 'gstTaxValue',
                        },
                        insuranceValueWithGst: {
                            display: 'insuranceValueWithGst',
                            path: 'insuranceValueWithGst',
                        },
                    }}
                    customActions={[
                        {
                            heading: 'Approve',
                            // eslint-disable-next-line react/prop-types
                            Render: ({ record }) => {
                                if (hasApprovePermission && canApprove) {
                                    return (
                                        <span
                                        // eslint-disable-next-line react/prop-types
                                            key={record._id}
                                        >
                                            {/* eslint-disable-next-line react/prop-types */}
                                            {record.isApproved ? 'Approved' : 'Not Approved'}
                                        </span>
                                    );
                                }

                                // eslint-disable-next-line react/prop-types
                                if (record.isApproved) {
                                    return (
                                        <span
                                        // eslint-disable-next-line react/prop-types
                                            key={record._id}
                                        >
                                            Approved
                                        </span>
                                    );
                                }

                                return (
                                    <button
                                    // eslint-disable-next-line react/prop-types
                                        key={record._id}
                                        type="button"
                                        className="btn btn-warning"
                                        onClick={() => {
                                            onApproveClick(record);
                                        }}
                                    >
                                        Approve
                                    </button>
                                );
                            },
                        },
                    ]}
                />
            </div>
        </div>
    );
};

VehicleInsuranceQuotationList.propTypes = {
    canApprove: PropTypes.bool.isRequired,
    onApproveClick: PropTypes.func.isRequired,
    quotations: PropTypes.arrayOf({}).isRequired,
};

export default VehicleInsuranceQuotationList;
